import { ETrackerEvents, trackCustom } from '../index';

import { formatTrackerMoney, type IRechargePayExtras } from './recharge-result';

const DEFAULT_GATEWAY_NAME = 'paypal';

/** 第三方支付面板成功拉起并在屏幕展现时上报 */
export function trackGatewayShow(params: {
    order_id: string;
    gear_id: string;
    payExtras: Pick<IRechargePayExtras, 'money' | 'goods_type'>;
    gateway_name?: string;
}): void {
    const { order_id, gear_id, payExtras, gateway_name = DEFAULT_GATEWAY_NAME } = params;
    if (!order_id?.trim()) {
        return;
    }

    trackCustom(ETrackerEvents.GATEWAY_SHOW, {
        order_id,
        gateway_name,
        gear_id,
        goods_type: payExtras.goods_type,
        money: formatTrackerMoney(payExtras.money),
    });
}
